export default __webpack_public_path__ + "static/media/shazams-example.0eb33a30.png";